import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA,  NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RouterOutlet } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PopupDeconnectedUserComponent } from './components/popup/popup-deconnected-user/popup-deconnected-user.component';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { TemplatePopupVisitorComponent } from './components/templates/template-popup-visitor/template-popup-visitor.component';
registerLocaleData(localeFr, 'fr');


@NgModule({
  declarations: [
    AppComponent,
    SnackbarComponent,
    TemplatePopupVisitorComponent,
    PopupDeconnectedUserComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    RouterOutlet,
    NgbModule
  ],
  exports: [
  ],
  providers: [
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }